export default {
  state: () => ({
    dietitians: {},
    currentDietitian: ''
  })
}



// WEBPACK FOOTER //
// ./src/app/store/dietitians/config.js